import React, { PureComponent } from 'react';
import { PrimaryButton, DLAutoComplete } from 'appSrc/components/UI';
import { VideoImageSelector } from 'appSrc/components/Shards';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import TagEditor from 'appSrc/components/Tag/Editor';
import Edit from 'appSrc/components/Icons/Edit';
import { FormTextField, FormToggle, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import CategorySelectModal from 'appSrc/AdminPanel/pages/Modals/Category/Select';
import { dAPI } from 'appSrc/api';
import { debounce } from 'throttle-debounce';
import style from './styles/style.module.css';

class ArticleForm extends PureComponent {
    constructor( props ) {
        super( props );

        let authorName = props.initialValues.author ? props.initialValues.author.displayName : '';
        this.state = {
            selectedImage: props.initialValues.cover_image,
            userSearch: authorName,
            userOptions: [],
            userSelected: !!props.initialValues.author,
            categories: props.initialValues.categories || [],
            tags: props.initialValues.tags ? props.initialValues.tags : [],
            s3File: props.initialValues.contentS3File,
            vTTS3File: props.initialValues.contentVTTS3File,
            uploading: false,
            uploadingVTT: false,
        };
    }
    updateTags = ( tags ) => {
        this.setState( { tags } );
    }
    updateCover = ( values ) => {
        let imageData = values.selectedImage;
        let ytUrl = values.youtubeLink;
        if( imageData != null ) {
            this.props.changeFieldValue( 'cover_image', imageData );
            this.props.changeFieldValue( 'video_url', ytUrl );
        }
        this.setState( {
            selectedImage: imageData,
            showCoverModal: false,
        } );
    }
    updateCategories = ( { checked, data } ) => {
        this.categoryIds = checked;
        this.props.changeFieldValue( 'categories', data );

        this.setState( {
            categories: data,
            showCategorySelect: false,
        } );
    }
    updateUserSearch = ( e, { value } ) => {
        this.setState( {
            userSearch: value,
        } );
        debounce( 50, this.searchForUser( value ) );
    }
    searchForUser = ( name ) => {
        this.props.getUsers( {
            page: 1,
            limit: 4,
            sort: 'displayName,userid',
            search: name || undefined,
        } )
        .then( ( users ) => {
            this.setState( { userOptions: users } );
        } );
    }
    selectUser = ( e, { result } ) => {
        let user = {
            displayName: result.title.replace( /^\d+:\s/, '' ),
            userid: result.value,
        };
        this.props.changeFieldValue( 'user_id', user.userid );
        this.setState( { userSearch: user.displayName, userOptions: [], userSelected: true } );
    }
    catchKeyPress = ( e ) => {
        if( e.key == 'Enter' ) {
            e.preventDefault();
        }
    }
    
    deleteHostedFile = async () => {
        try {
            await this.props.deleteFile(`/admin/files/${this.state.s3File.id}`);
            this.setState({ s3File: false });
        }
        catch(err) {
            console.log('ERR', err);
            alert('Error', err);
        }
    }

    deleteVTTFile = async () => {
        try {
            await this.props.deleteFile(`/admin/files/${this.state.vTTS3File.id}`);
            this.setState({ vttS3File: false });
        }
        catch(err) {
            console.log('ERR', err);
            alert('Error', err);
        }
    }

    submitHandler = ( values ) => {
        var data = { ...values };

        if( data.interestId !== null && data.interestId !== undefined ) {
            data.interestIds = [ data.interestId ];
        }

        // if rankedArticle is set to false, it's always fine to submit as false
        if ( data.rankedArticle !== true ) {
            data.featured = false;
        }
        else {
            // rankedArticle is set to true;
            // if data is already featured, do not set it again (this would put it at the top of the featured items)
            if ( data.featured ) {
                data.featured = undefined;
            }
            else {
                data.featured = true;
            }
        }
        data.contentS3File = this.state.s3File;
        data.contentVTTS3File = this.state.vTTS3File;
        data.s3_file_id = this.state.s3File ? this.state.s3File.id : null;
        data.vtt_s3_file_id = this.state.vTTS3File ? this.state.vTTS3File.id : null;
        data.categoryIds = this.categoryIds;
        data.cover_image = this.state.selectedImage;

        this.props.onSubmit( { article: data, tags: this.state.tags } );
    }

    selectHostedFile = async (e) => {
        const files = e.target.files;
        const file = files[0];
        if (file == null) {
            return alert('No file selected.');
        }
        try {
            
            this.setState({ uploading: true });
            let response = await this.props.getSignedRequest({ name: file.name });
            await this.props.uploadFile(response.signedRequest, file);
            let s3File = await this.props.createFileOnly({
                key: file.name,
                type: file.type,
            });
            this.setState( { s3File: s3File } );
            this.setState( { uploading: false } );
            alert('The video file has been uploaded. Make sure to save/submit this form.');
            
        } catch (err) {
            this.setState({ uploading: false });
            alert('Error creating file', err);
        }
    }

    selectVTTFile = async (e) => {
        const files = e.target.files;
        const file = files[0];
        if (file == null) {
            return alert('No file selected.');
        }
        try {
            
            this.setState({ uploadingVTT: true });
            let response = await this.props.getSignedRequest({ name: file.name });
            await this.props.uploadFile(response.signedRequest, file);
            let s3File = await this.props.createFileOnly({
                key: file.name,
                type: file.type,
            });
            this.setState( { vTTS3File: s3File } );
            this.setState( { uploadingVTT: false } );
            alert('The vtt file has been uploaded. Make sure to save/submit this form.');

        } catch (err) {
            this.setState({ uploadingVTT: false });
            alert('Error creating file', err);
        }
    }

    render() {
        const { handleSubmit } = this.props;
        const { uploading, uploadingVTT, selectedImage, userSearch, userOptions, userSelected, categories } = this.state;

        const searchResults = userOptions.map( ( user ) => {
            return {
                title: `${ user.userid }: ${user.displayName}`,
                value: user.userid,
            };
        } );
        const showResults = searchResults.length > 0;

        return (
            <div>
                <Form className={ style.articleForm } onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>
                        <div className={ style.imageWrapper } onClick={ () => { this.setState( { showCoverModal: true } ); } }>
                            <img src={ selectedImage } />
                            <br />
                            <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } />Edit Image/Video</span>
                        </div>
                        <div className={ style.detailsWrapper }>
                            <Field
                            id="title"
                            name="title"
                            label="Title"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="content_type_id"
                            name="content_type_id"
                            label="Content Type"
                            component="select"
                            style={ { marginTop: '10px', marginBottom: '20px' } }>
                                <option value="2">Article</option>
                                <option value="4">Class</option>
                                <option value="5">How-To</option>
                            </Field>

                            <div className={ style.categoriesField } >
                                <div className={ style.fieldTitle }>Categories:</div>
                                <p onClick={ () => { this.setState( { showCategorySelect: true } ); } }>{ categories.map( category => category.name ).join( ', ' ) }</p>
                            </div>

                            <TagEditor
                            label='Tags'
                            style={ { marginTop: '15px', maxWidth: '350px' } }
                            currentTags={ this.props.initialValues.tags ? this.props.initialValues.tags : [] }
                            onUpdate={ this.updateTags } />

                            <div onKeyPress={ this.catchKeyPress }>
                                <DLAutoComplete
                                value={ userSearch }
                                label='Article Author*'
                                onChange={ this.updateUserSearch }
                                onResultSelect={ this.selectUser }
                                results={ searchResults }
                                open={ showResults }
                                maxLength='40'
                                fullWidth
                                style={ { marginTop: '7px' } } />
                            </div>

                            <Field
                            id="short_description"
                            name="short_description"
                            component={ FormTextArea }
                            label="Short Description (160 characters max)"
                            maxLength={ 160 }
                            fullWidth />

                            <Field
                            id="preview_video_url"
                            name="preview_video_url"
                            label="Preview Video Link"
                            component={ FormTextField }
                            fullWidth />

                            <div>
                                <label>Hosted Video File</label>
                                <br />
                                { !uploading && !this.state.s3File &&
                                    <input type='file' name="s3_file" id="s3_file" onChange={ (e)=> { 
                                        this.selectHostedFile(e);
                                    } } />
                                }
                                { uploading == true &&
                                    <>
                                    Uploading...
                                    </>
                                }
                                { !uploading && this.state.s3File &&
                                    <>
                                        <a onClick={ () => { this.deleteHostedFile(); } }> {this.state.s3File.key}<br />Delete Hosted File</a><br />
                                        <video controls={true} src={ `https://d2220ok937f3dq.cloudfront.net/${this.state.s3File.key}` } width='200' />
                                    </>
                                }
                                <br />
                                <br />
                            </div>

                            { this.state.s3File && 
                                <div>
                                    <label>VTT File</label>
                                    <br />
                                    { !uploadingVTT && !this.state.vTTS3File &&
                                        <input type='file' name="vtt_s3_file" id="vtt_s3_file" onChange={ (e)=> { 
                                            this.selectVTTFile(e);
                                        } } />
                                    }
                                    { uploadingVTT == true &&
                                        <>
                                        Uploading...
                                        </>
                                    }
                                    { !uploadingVTT && this.state.vTTS3File &&
                                        <>
                                            <a onClick={ () => { this.deleteVTTFile(); } }> {this.state.vTTS3File.key}<br />Delete VTT File</a>
                                        </>
                                    }
                                    <br />
                                    <br />
                                </div>
                            }

                            <Field
                            id="locked"
                            name="locked"
                            label="Locked"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } } />
                            <Field
                            id="published"
                            name="published"
                            label="Published"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />
                            <Field
                            id="deactivated"
                            name="deactivated"
                            label="Deactivated"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />
                            <Field
                            id="rankedArticle"
                            name="rankedArticle"
                            label="Featured"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />

                            <PrimaryButton
                            label="Submit"
                            fullWidth
                            type="submit"
                            disabled={ !userSelected }
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
                { this.state.showCoverModal &&
                    <VideoImageSelector
                    initialValues={ { selectedImage: selectedImage, youtube: this.props.initialValues.video_url } }
                    closeHandler={ () => { this.setState( { showCoverModal: false } ); } }
                    onSubmit={ this.updateCover } />
                }
                { this.state.showCategorySelect &&
                    <CategorySelectModal initialValues={ this.props.initialValues.categories }
                    onSubmit={ this.updateCategories }
                    closeHandler={ () => { this.setState( { showCategorySelect: false } ); } } />
                }
            </div>
        );
    }
}

ArticleForm.defaultProps = {
    initialValues: {},
};

ArticleForm = reduxForm( {
    form: 'ArticleForm',
} )( ArticleForm );

const mapStateToProps = ( state ) => {
    return {
        listInterests: state.vars.interests,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'ArticleForm', field, value ) );
        },
        getUsers: ( queryObject ) => {
            return dAPI.get( '/admin/users', queryObject );
        },
        getSignedRequest: ( queryObject ) => {
            return dAPI.get( '/admin/files/getsignedrequest', queryObject );
        },
        uploadFile: ( url, file ) => {
            return dAPI.put( url, file );
        },
        createFileOnly: ( queryObject ) => {
            return dAPI.post( '/admin/files/createfileonly', queryObject );
        },
        deleteFile: ( url ) => {
            return dAPI.delete( url );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ArticleForm );
